<template>
  <PageVenueFilter :value="venueId" @input="$store.dispatch('pos/general/selectVenueId', $event)">
    <zReports v-if="venueId" :venueId="venueId" />
  </PageVenueFilter>
</template>

<script>
import { mapGetters } from "vuex";
import PageVenueFilter from "@/components/Custom/PageVenueFilter.vue";
import zReports from "./zReports.vue";

export default {
  components: {
    PageVenueFilter,
    zReports
  },
  computed: {
    ...mapGetters({
      venueId: "pos/general/selectedVenueId"
    })
  }
};
</script>